import { useState } from 'react';
import { motion } from 'framer-motion';
import { ModalFrame } from '../ui/modal';
import { IconClose, IconUsers } from '../ui/icons';
import { Toggle } from '../ui/toggle';
import '../po/drawer.css';

const SWATCHES = ['#7c3aed', '#0ea5e9', '#10b981', '#f97316', '#db2777', '#2563eb', '#ca8a04', '#dc2626', '#0d9488', '#475569'];

// Admin-only: list / add / edit / (de)activate projects. Writes hand rows up
// to the page, which mutates local state + logs activity (frontend phase).
export default function ManageProjectsModal({ projects, onClose, onAddProject, onUpdateProject }) {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [color, setColor] = useState(SWATCHES[0]);

  function add() {
    if (!name.trim()) { alert('Project name is required.'); return; }
    onAddProject({ name: name.trim(), url: url.trim() || null, color });
    setName(''); setUrl(''); setColor(SWATCHES[0]);
  }

  return (
    <ModalFrame onClose={onClose}>
      <motion.div
        role="dialog"
        initial={{ opacity: 0, y: 12, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 12, scale: 0.98 }} transition={{ duration: 0.18 }}
        style={{ width: 'min(560px, calc(100vw - 48px))', maxHeight: 'calc(100vh - 96px)', background: '#fff', borderRadius: 16, boxShadow: '0 24px 60px rgba(15,20,25,0.22), 0 2px 6px rgba(15,20,25,0.08)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      >
        <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border-subdued)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 30, height: 30, borderRadius: 8, background: 'var(--surface-inverted)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <IconUsers size={15} />
            </div>
            <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-emphasized)' }}>Manage Projects</div>
          </div>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-subdued)', padding: 6, display: 'flex' }}>
            <IconClose size={16} />
          </button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
            {projects.map(p => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', border: '1px solid var(--border-subdued)', borderRadius: 10 }}>
                <span style={{ width: 10, height: 10, borderRadius: 999, background: p.color || '#64748b', flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-emphasized)' }}>{p.name}</div>
                  {p.url && <div style={{ fontSize: 11, color: 'var(--text-subdued)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.url}</div>}
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'var(--text-subdued)' }}>
                  <Toggle checked={p.active} onChange={v => onUpdateProject(p.id, { active: v })} />
                  {p.active ? 'Active' : 'Off'}
                </label>
              </div>
            ))}
          </div>

          <div className="subsection">
            <div className="subsection-label">Add a project</div>
            <div className="subsection-body">
              <div className="form-group"><label className="form-label">Name</label>
                <input className="form-input" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. ServiceCo" />
              </div>
              <div className="form-group"><label className="form-label">URL <span className="field-hint">optional</span></label>
                <input className="form-input" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://..." />
              </div>
              <div className="form-group" style={{ marginBottom: 0 }}><label className="form-label">Color</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {SWATCHES.map(c => (
                    <button key={c} type="button" onClick={() => setColor(c)}
                      style={{ width: 24, height: 24, borderRadius: 999, background: c, cursor: 'pointer', border: color === c ? '2px solid var(--text-emphasized)' : '2px solid transparent', boxShadow: color === c ? '0 0 0 2px #fff inset' : 'none' }} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, padding: '14px 20px', borderTop: '1px solid var(--border-subdued)', flexShrink: 0 }}>
          <button className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>Done</button>
          <button className="btn btn-primary" style={{ flex: 1 }} onClick={add}>+ Add Project</button>
        </div>
      </motion.div>
    </ModalFrame>
  );
}
